import { render, staticRenderFns } from "./PictureLessonMockup.vue?vue&type=template&id=4fa18cc9&"
import script from "./PictureLessonMockup.vue?vue&type=script&lang=js&"
export * from "./PictureLessonMockup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports